<template>
  <div :class="containerClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MessageType } from './constants'
import { messageTypes } from './constants'

defineOptions({
  name: 'SfModalMessage',
})

interface Props {
  variant?: MessageType
}

const props = withDefaults(defineProps<Props>(), {
  variant: messageTypes.info,
})

const containerClass = computed(() => {
  return {
    'sf-modal-message': true,
    [`sf-modal-message-${props.variant}`]: true,
  }
})
</script>
